import { RemoveGroupMemberScreenNavigationProps } from "./types"
import React from "react"
import RemoveGroupMember from "./remove-group-member-screen"
import { PageRoot } from "~screens/page-root"


const RemoveGroupChatScreen: React.FC<RemoveGroupMemberScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <RemoveGroupMember />
    </PageRoot>
  )
}

export default RemoveGroupChatScreen
